export default class SolicitarTrocaSenhaRequest {
    email: string;

    constructor(email: string) {
        this.email = email;
    }
}